// 仓库
import * as type from "../mutation-types"
const state = {
  data:window.localStorage.getItem("warehouse") || ""
}

const getters = {
  getWarehouse:state=>state.data
}

const mutations = {
  [type.USER_OUT_LOGIN](state){
    state.data = null
  }
}

const actions = {
  onUse(response){
    window.localStorage.setItem("warehouse",response)
  },
  outLogin({commit}){
    commit(type.USER_OUT_LOGIN)
    window.localStorage.removeItem("warehouse")
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}